// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tabsClass .el-tabs__content {\n  padding: 0;\n}\n.informationCont {\n  height: calc(100vh - 94px);\n  overflow-y: auto;\n  padding: 20px;\n}\n.informationFoot {\n  padding: 10px;\n  border-top: 1px solid #ccc;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
